import React, { useState, useEffect, useContext, useRef } from 'react';
import postulacionesParaAdminsServices from '../services/postulacionesParaAdminsServices';
import { InputContext } from '../contexts/InputContext';
import { errorClassification } from '../errorHandler';
import MessageModal from '../container/MessageModal';
import resourcesServices from '../services/resourcesServices';
import {useReactToPrint} from 'react-to-print';

const ListaAdmisibles = () => {

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  })

  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [postulaciones, setPostulaciones] = useState([]);
  const [ofertas, setOfertas] = useState({});
  const [saving, setSaving] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  useEffect(() => {
    if(authInformation.autenticado === true){
      if( authInformation.rol === 'Jurado' || authInformation.rol === 'Admin' ){
        obtenerAdmisiblesPublico(false);
      } else {
        obtenerAdmisiblesPublico(true);
      }
    } else if(authInformation.autenticado === false){
      obtenerAdmisiblesPublico(true);
    }
  }, [authInformation]);


  const obtenerAdmisiblesPublico = async (es_publico = false) => {
    try {
      const data = await postulacionesParaAdminsServices.listaAdmisibles(es_publico);

      const grupos = data.reduce((agrupados, item) => {
        const oferta_id = item.oferta_id;

        if (!agrupados[oferta_id]) {
          agrupados[oferta_id] = item.oferta.titulo;
        }

        return agrupados;
      }, {});

      setOfertas(grupos)

      setPostulaciones(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const actualizarEstadoPostulacion = async (postulacion_id, value) => {
    try {
      setSaving(true)
      const data = await resourcesServices.actualizarResource('postulaciones', postulacion_id, {postulacion: {admisible_es_publico: value}});

      const updatedPostulaciones = postulaciones.map(item =>
        item.id === data.id ? { ...item, admisible_es_publico: data.admisible_es_publico } : item
      );

      setPostulaciones(updatedPostulaciones)
      setSaving(false)

      // handleShowModal("Datos actualizados");
    } catch (error) {
      setSaving(false)
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const handleChecked = (e) => {
    const { name, value, checked } = e.target;
    actualizarEstadoPostulacion(value, checked)
  }

  const listarPostulaciones = postulaciones && ofertas && Object.keys(ofertas).map((oferta) => {

    return (
      <div key={oferta} className='p-3' ref={componentRef}>
        {
          <div className="mb-3">
          <h3>{ofertas[oferta]}</h3>
          <table className="table table-bordered table-sm mb-5">
            <thead>
              <tr>
                <th className="text-start" scope="col">Nombre</th>
                <th className="text-start" scope="col">Documento</th>
                {
                  (authInformation.autenticado === true && ( authInformation.rol === 'Jurado' || authInformation.rol === 'Admin' )) && (
                    <th className="text-start" scope="col">Público</th>
                  )
                }
              </tr>
            </thead>
            <tbody>
              {
                postulaciones && postulaciones.filter(p => p.oferta_id == oferta).map((postulacion, index) => {
                  return(
                    <tr className='text-start' key={index}>
                      <td className=''>{postulacion.nombre_publico_de_usuario}</td>
                      <td>{postulacion.documento_publico_de_usuario}</td>
                      {
                        (authInformation.autenticado === true && ( authInformation.rol === 'Jurado' || authInformation.rol === 'Admin' )) && (
                          <td>
                            {saving ? (
                              <div>guardando...</div>
                            ) :
                            (
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  value={`${postulacion.id}`}
                                  name={`publico_${postulacion.id}`}
                                  type="checkbox"
                                  onChange={(e) => handleChecked(e)}
                                  checked={postulacion.admisible_es_publico}
                                  role="switch" />
                              </div>
                            )}

                          </td>
                        )
                      }
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
          <button className="btn btn-dark btn-lg px-4" type="button" onClick={handlePrint} >Imprimir</button>
          </div>
        }
      </div>
    )
  })

  return (
    <>
      <div>
        <h1>Listado de inscriptos</h1>
        <div className="container">
            {listarPostulaciones}
        </div>
      </div>

      <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
      />
    </>
  );
};

export default ListaAdmisibles;